import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info__header" }
const _hoisted_2 = { class: "header-name" }
const _hoisted_3 = { class: "header-member-id" }
const _hoisted_4 = { class: "info__section" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "info__section" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "任課的班級", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    class: "letwecare-member-info-drawer",
    placement: "right",
    closable: _ctx.device.mobile ? true : false,
    visible: _ctx.visible,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.coachData.name), 1),
        _createElementVNode("span", _hoisted_3, "會員編號：" + _toDisplayString(_ctx.coachData.member_id), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_descriptions, { column: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "性別" }, {
              default: _withCtx(() => [
                (_ctx.coachData.gender == 'male')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "先生"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "女士"))
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "生日" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.coachData.birthdate) + " (" + _toDisplayString(_ctx.calculateAge(_ctx.coachData.birthdate)) + ")", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "聯絡電話" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.coachData.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "LINE ID" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.coachData.line_friend_id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "地址" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.coachData.address), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_divider),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.coursesData.length > 0)
          ? (_openBlock(), _createBlock(_component_a_row, {
              key: 0,
              gutter: 12
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesData, (course) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    class: "mb-3",
                    lg: 24,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        hoverable: "",
                        onClick: ($event: any) => (_ctx.toCoursePage(course.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card_meta, {
                            title: course.semester + ' ' + course.name,
                            description: course.description
                          }, null, 8, ["title", "description"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              image: _ctx.simpleImage,
              description: "尚未有任課的班級"
            }, null, 8, ["image"]))
      ])
    ]),
    _: 1
  }, 8, ["closable", "visible", "onClose"]))
}